import { UseGetAgenticWorkflowDetailsParams } from 'services/hooks/queries/useGetAgenticWorkflowDetails';
import axiosInstance from './config/api';
import { CallType, Disposition, CallStatistic } from 'types/call.type';
import { SMSStatistic } from 'types/sms.type';
import { PartyStages } from './getPartyStages';

export const Status = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
} as const;

export type Party = {
    callId: string;
    callDate: string;
    callOutcome: keyof typeof CallType;
    duration: number;
    crmStatus: keyof typeof PartyStages;
    crmId: string;
    name: string;
    phoneNumber: string;
    transferTo: string;
    disposition: keyof typeof Disposition;
};

export type AgenticWorkflowDetails = {
    status: keyof typeof Status;
    callStatusStats: any[] | null;
    callsToAgentRatio: number;
    expectedPendingCalls: number;
    overdueCalls?: any;
    parties: Party[] | null;
    partyStages: (keyof typeof PartyStages)[];
    callStatistic: CallStatistic;
    smsStatistic?: SMSStatistic;
    hasAssignedAgents?: boolean;
    allowCallsWithoutOnlineAgents?: boolean;
    pagination: {
        totalPages: number;
        totalRecords: number;
        currentPage: number;
        perPage: number;
    };
};

export const getAgenticWorkflowDetails = (props: UseGetAgenticWorkflowDetailsParams) => {
    const { id, startDate, endDate, ...rest } = props;
    const isoStartDate = startDate.toISOString();
    const isoEndDate = endDate.toISOString();

    return axiosInstance
        .get<AgenticWorkflowDetails>(`/workflows/${id}`, {
            params: { startDate: isoStartDate, endDate: isoEndDate, ...rest },
        })
        .then((res) => res.data);
};
